import { defaultTreeAdapter, parseFragment, serialize } from 'parse5';
import type { DefaultTreeAdapterTypes } from 'parse5';

type StyleAttributeHandler = (element: DefaultTreeAdapterTypes.Element, value: string) => void;

export const removeInlineStyleAttributes = (html: string, onStyleAttribute?: StyleAttributeHandler) => {
  const fragment = parseFragment(html, { scriptingEnabled: false });
  const pending: DefaultTreeAdapterTypes.Node[] = [fragment];

  for (let node = pending.pop(); node; node = pending.pop()) {
    if ('childNodes' in node) {
      for (const child of node.childNodes) {
        pending.push(child);
      }
    }
    if ('content' in node) {
      pending.push(node.content);
    }
    if (!defaultTreeAdapter.isElementNode(node)) {
      continue;
    }

    const style = node.attrs.find(attribute => attribute.name.toLowerCase() === 'style');
    node.attrs = node.attrs.filter(attribute => attribute.name.toLowerCase() !== 'style');

    if (style) {
      onStyleAttribute?.(node, style.value);
    }
  }

  return serialize(fragment, { scriptingEnabled: false });
};
